<!--
<app-picture class="sign-in-google" srcset="assets/images/sign-in-with-google" [formats]="['svg', 'png']"></app-picture>
-->
<div *ngIf="!isSmall" class="sign-in-google-lg"></div>
<div *ngIf="isSmall" class="sign-in-google-sm"></div>
